import { getDefaultClient } from '@arcubase/client-ts'
import type {
  AuthCredentialReqVO,
  AuthCredentialRespVO,
  AuthEmailVerifyChangeReqVO,
  AuthEmailVerifyChangeRespVO,
  AuthEmployeeIdLoginReqVO,
  AuthEmployeeIdLoginRespVO,
  AuthIdCardLoginReqVO,
  AuthIdCardLoginRespVO,
  AuthPasswordLoginReqVO,
  AuthPasswordLoginRespVO,
  AuthRegisterReqVO,
  AuthRegisterRespVO,
  AuthResetPasswordReqVO,
  AuthResetPasswordRespVO,
  AuthSendResetPasswordEmailReqVO,
  AuthSendResetPasswordEmailRespVO,
  AuthStrategyRespVO,
  AuthVerifyEmailResetPasswordCodeReqVO,
  AuthVerifyEmailResetPasswordCodeRespVO
} from '@arcubase/client-ts'

// @endpoint POST /auth/login-credential
// @controller Auth.Credential
export async function sendAuthCredential(
  data: AuthCredentialReqVO
): Promise<AuthCredentialRespVO> {
  return getDefaultClient().post('/auth/login-credential', data)
}

// @endpoint POST /auth/set-email-verify
// @controller Auth.EmailVerifyChange
export async function sendAuthEmailVerifyChange(
  data: AuthEmailVerifyChangeReqVO
): Promise<AuthEmailVerifyChangeRespVO> {
  return getDefaultClient().post('/auth/set-email-verify', data)
}

// @endpoint POST /auth/employee-id-login
// @controller Auth.EmployeeIdLogin
export async function sendAuthEmployeeIdLogin(
  data: AuthEmployeeIdLoginReqVO
): Promise<AuthEmployeeIdLoginRespVO> {
  return getDefaultClient().post('/auth/employee-id-login', data)
}

// @endpoint POST /auth/login-with-idcard
// @controller Auth.IdCardLogin
export async function sendAuthIdCardLogin(
  data: AuthIdCardLoginReqVO
): Promise<AuthIdCardLoginRespVO> {
  return getDefaultClient().post('/auth/login-with-idcard', data)
}

// @endpoint POST /auth/login
// @controller Auth.PasswordLogin
export async function sendAuthPasswordLogin(
  data: AuthPasswordLoginReqVO
): Promise<AuthPasswordLoginRespVO> {
  return getDefaultClient().post('/auth/login', data)
}

export async function exchangeAuthLoginCode(
  data: { code: string; browser_ident_hash: string }
): Promise<AuthPasswordLoginRespVO> {
  return getDefaultClient().post('/auth/login-code/exchange', data)
}

// @endpoint POST /account/register
// @controller Auth.Register
export async function sendAuthRegisterAccount(
  data: AuthRegisterReqVO
): Promise<AuthRegisterRespVO> {
  return getDefaultClient().post('/account/register', data)
}

// @endpoint POST /auth/reset-password/:id
// @controller Auth.ResetPassword
export async function sendAuthResetPassword(
  id: string,
  data: AuthResetPasswordReqVO
): Promise<AuthResetPasswordRespVO> {
  return getDefaultClient().post(`/auth/reset-password/${id}`, data)
}

// @endpoint POST /auth/send-reset-email
// @controller Auth.SendResetPasswordEmail
export async function sendAuthResetPasswordEmail(
  data: AuthSendResetPasswordEmailReqVO
): Promise<AuthSendResetPasswordEmailRespVO> {
  return getDefaultClient().post('/auth/send-reset-email', data)
}

// @endpoint POST /auth/verify-reset-email/:id
// @controller Auth.VerifyEmailResetPasswordCode
export async function sendAuthVerifyEmailResetPasswordCode(
  id: string,
  data: AuthVerifyEmailResetPasswordCodeReqVO
): Promise<AuthVerifyEmailResetPasswordCodeRespVO> {
  return getDefaultClient().post(`/auth/verify-reset-email/${id}`, data)
}

// @endpoint GET /auth/strategy
// @controller Auth.Strategy
export async function getAuthStrategy(): Promise<AuthStrategyRespVO> {
  return getDefaultClient().get('/auth/strategy')
}
